/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type ScoreConfigDataType = "NUMERIC" | "BOOLEAN" | "CATEGORICAL";
export const ScoreConfigDataType = {
  Numeric: "NUMERIC",
  Boolean: "BOOLEAN",
  Categorical: "CATEGORICAL",
} as const;
